/* Copyright © 2023 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and */
/* matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, */
/* including without limitation, material generated from the software programs which are displayed on the screen such */
/* as icons, screen display looks, etc. */

import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { XdaStringsService } from '../../../services/xda-strings.service';
import { SettingType } from '../../../../common/enums';

@Component({
  selector: 'add-custom-string-component',
  templateUrl: './add-custom-string.component.html',
  styleUrls: ['./add-custom-string.component.less'],
  standalone: false,
})
export class AddCustomStringModalComponent implements AfterViewInit {
  @ViewChild('input', { static: false }) input: ElementRef;

  title = 'SDE_ADD_CUSTOM';
  placeholder = 'SDE_ENTER_CUSTOM_WORD';
  value: string;

  matchCriteria = {
    name: 'match criteria',
    label: 'SDE_MATCH_CRITERIA',
    selectedValue: {
      key: 'SDE_CONTAINS',
      value: true,
      customString: '',
    },
    options: [
      {
        key: 'SDE_CONTAINS',
        value: true,
        isDefault: true,
      },
      {
        key: 'SDE_MATCH',
        value: false,
        isDefault: false,
      },
    ],
    selectedValue2: {
      key: '',
      value: '',
      title: '',
      options: null,
    },
    options2: [],
    placeholder: '',
    required: false,
    setDocumentLanguage: '',
    toLanguage: '',
    optionListName: '',
    optionListName2: '',
    type: SettingType.Select,
  };

  constructor(
    public activeModal: NgbActiveModal,
    private xdaStringsService: XdaStringsService,
  ) {
    this.placeholder = this.xdaStringsService.strings[this.placeholder];
    this.title = this.xdaStringsService.strings[this.title];
    this.value = '';
  }

  ngAfterViewInit() {
    this.input.nativeElement.focus();
  }
}
